import { AbstractControl, ValidationErrors } from '@angular/forms';

export function noWhitespaceOnlyValidator(form: AbstractControl): ValidationErrors {
    return !form.value?.replace(/\s/g, '').length && form.value ? {whitespace: true} : null;
}
